<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <!-- Logo -->
    <a class="navbar-brand" href="#">
      <img src="assets/img/logo_simple.png" alt="Logo" class="logo" />
      <h4>e-cclesia</h4>
    </a>

    <!-- Toggle button for mobile -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Collapsible navbar links aligned to the right -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item active">
          <a class="nav-link" aria-current="page" href="#about">Acerca</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#services">Servicios</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#reports">Reportes</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#price">Precios</a>
        </li>
        <!--<li class="nav-item">
          <a class="nav-link" href="#contact">Contacto</a>
        </li>-->
      </ul>
    </div>
  </div>
</nav>